import React from "react";
import { Helmet } from "react-helmet-async";

import ContactHero from "../components/contact/ContactHero";
import GlobalCta from "../components/global/GlobalCta";
import FujairahTextImage from "../components/truck-rental-fujairah/FujairahTextImage";
import FujairahTextSection from "../components/truck-rental-fujairah/FujairahTextSection";
import FujairahFaq from "../components/truck-rental-fujairah/FujairahFaq";
import VanRentalTable from "../components/van-rental-dubai/VanRentalTable";

import { chillerVanJebelAliSections } from "../components/chiller-van-jebel-ali/chillerVanJebelAliSections";
import "../components/truck-rental-fujairah/truck-rental-fujairah.css";
import "../components/van-rental-dubai/van-rental-dubai.css";
import "../components/chiller-van/chiller-van.css";

const ChillerVanForRentInJebelAli = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "cvj-hero":
        return (
          <ContactHero
            key={index}
            variant="chiller-van"
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "cvj-text-image":
        return (
          <FujairahTextImage
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            reverse={section.reverse}
            altBg={section.altBg}
          />
        );

      case "cvj-text-only":
        return (
          <FujairahTextSection
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "cvj-table":
        return (
          <VanRentalTable
            key={index}
            title={section.title}
            description={section.description}
            intro={section.intro}
            columns={section.columns}
            rows={section.rows}
            notes={section.notes}
            background={section.background}
          />
        );

      case "cvj-faq":
        return (
          <FujairahFaq
            key={index}
            title={section.title}
            faqs={section.faqs}
          />
        );

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Chiller Van Rental in Jebel Ali | From AED 300/Day | Chiller Fleet</title>
        <meta name="description" content="Chiller van rental in Jebel Ali and JAFZA — scheduled dispatch timed against customs release, gate passes arranged ahead. 0°C to 8°C for the free zone and Dubai South cold chain." />
        <link rel="canonical" href="https://chillerfleet.com/chiller-van-for-rent-in-jebel-ali" />
        <meta property="og:title" content="Chiller Van Rental in Jebel Ali | From AED 300/Day | Chiller Fleet" />
        <meta property="og:description" content="Chiller van rental in Jebel Ali and JAFZA — scheduled dispatch timed against customs release, gate passes arranged ahead. 0°C to 8°C for the free zone and Dubai South cold chain." />
        <meta property="og:url" content="https://chillerfleet.com/chiller-van-for-rent-in-jebel-ali" />
        <meta name="twitter:title" content="Chiller Van Rental in Jebel Ali | From AED 300/Day | Chiller Fleet" />
        <meta name="twitter:description" content="Chiller van rental in Jebel Ali and JAFZA — scheduled dispatch timed against customs release, gate passes arranged ahead. 0°C to 8°C for the free zone and Dubai South cold chain." />
      </Helmet>

      {chillerVanJebelAliSections.map(renderSection)}
    </>
  );
};

export default ChillerVanForRentInJebelAli;
